import React from 'react';
import cx from 'classnames';

import ArrowSvg from 'app/components/common/Arrow';

import s from './Dynamics.module.sass';

type DynamicsProps = {
  dynamics: string | 'inf'
  className?: string
};

enum ArrowTypeEnum {
  ASCENDING = 'ascending',
  DESCENDING = 'descending',
}

const Dynamics: React.FC<DynamicsProps> = ({
  dynamics,
  className,
}) => {
  if (dynamics === 'inf') {
    return (
      <div className={s.dynamics}>
        <span className={cx(s.infinity)}>
          ∞
        </span>
      </div>
    );
  }
  const arrowType = +dynamics >= 0 ? ArrowTypeEnum.ASCENDING : ArrowTypeEnum.DESCENDING;
  const typeOfDynamics = {
    ascending: arrowType === ArrowTypeEnum.ASCENDING,
    descending: arrowType === ArrowTypeEnum.DESCENDING,
  };

  const compoundArrowClassName = cx(
    s.dynamics,
    { [s.descending]: typeOfDynamics.descending },
    className,
  );

  return (
    <div className={compoundArrowClassName}>
      <span className={cx(s.percent)}>
        {typeOfDynamics.ascending ? `+${Number(dynamics).toFixed(2)}` : Number(dynamics).toFixed(2)}
        %
      </span>

      <ArrowSvg className={cx(s.arrow)} theme={arrowType} />
    </div>
  );
};

export default Dynamics;
